import { Component, OnInit, Inject, Renderer2, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { Subject } from 'rxjs';
import { SharedDataService } from './shared/services/shared-data.service';
import { DOCUMENT } from '@angular/common';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { LocalStorageService } from './shared/services/local-storage-service';

@Component({
  selector: 'db-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  title = 'Document Builder';
  permissionsChecked: boolean;
  showHideUAT: boolean;
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  theme: string;

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private sharedDataService: SharedDataService,
    private renderer: Renderer2,
    private _localStorageService: LocalStorageService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    this.setLoginDisplay();

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      })

    this.setTheme();
    this.checkEnvironment();
  }

  ngAfterViewInit() {
    const favIcon = this.renderer.selectRootElement('#favIcon');
    favIcon.setAttribute('href', `assets/images/${this.getThemeValue(this.theme)}.ico`);
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount(){
    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(null);
    this._destroying$.complete();
  }

  setTheme() {
    this.theme = this._localStorageService.getItem('theme');
    this.renderer.addClass(this.document.body, this.getThemeValue(this.theme));
    this.sharedDataService.isProduction = environment.isProduction;
    this.showHideUAT = this.sharedDataService.isProduction;
  }

  private getThemeValue(theme: string): string {
    switch (theme) {
      case 'Croner':
        return 'croner-theme';
      case 'Peninsula':
        return 'peninsula-theme';
      case 'BrightHR':
        return 'bright-theme';
      default:
        return 'peninsula-theme';
    }
  }

  checkEnvironment() {
    this.sharedDataService.isProduction = environment.isProduction;
  }

  hasRoute(route: string): boolean {
    return this.router.url.includes(route);
  }
}
